import React, { useEffect, useState } from "react";
import { Edit, SimpleForm, TextInput, required, TopToolbar, Button, useRedirect,  DateInput, AutocompleteInput, useNotify } from "react-admin";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { getNameAndCompanyNamewithAddress } from "../common";

const ContactHistoryEdit = () => {
  const redirect = useRedirect();
  const { id } = useParams(); 
  const notify = useNotify();

  const [customers,setCustomers]=useState([]);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, marginBottom:-2 }}>
        <TopToolbar>
            <Button
                label="問い合わせ詳細表示"
                onClick={() => redirect(`/contactHistory/show/${id}`)}
                startIcon={<VisibilityIcon />}
            />
        </TopToolbar>
    </Box>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Edit mutationMode="pessimistic"
        mutationOptions={{ 
          onSuccess: () => {
            notify('更新が完了しました', { type: 'success' }); 
            // redirect('list', 'contactHistory');
            window.history.back();
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
          <AutocompleteInput
            source="customerId"
            label="顧客名"
            choices={customers.map(req => ({
              id: req.id, 
              name: `${getNameAndCompanyNamewithAddress(req)}`
            }))}
            validate={required()}
            allowEmpty
            freeSolo  
          />
          <DateInput source="contactDate" label="問い合わせ日" inputProps={{ max: '9999-12-31' }}/>
          <TextInput source="content" label="問い合わせ内容" multiline rows={5}/>
        </SimpleForm>
      </Edit>
    </>
  )

};

export default ContactHistoryEdit;
